import React from "react";
import { CircleLoading } from "react-loadingg";

export default function Loading() {
  return (
    <div className="loading widget-background">
      <div
        style={{
          display: "flex",
          overflow: "hidden",
          justifyContent: "center",
          alignItems: "center",
          height: "60px",
          background: "#272C34",
        }}
      >
        <div
          style={{
            position: "absolute",
            marginTop: "-8px",
          }}
        >
          <CircleLoading speed="1" color="#00bcd4" />
        </div>
      </div>
    </div>
  );
}
